export const convertDateToUtcWithoutChangingTime = (value) => {
  if (!value) return '';
  const date = new Date(value);
  const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  const newDateString = newDate.toISOString();
  return newDateString;
};

export const convertDateToLocalFromUtc = (value) => {
  if (!value) return '';
  const date = new Date(value);
  const newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  const newDateString = newDate.toISOString();
  return newDateString;
};
